<div class="avatar-text"
     [style.width]="sizeAvatar + 'px'"
     [style.height]="sizeAvatar + 'px'"
     [style.font-size]="(charAvatar.length > 1 ? sizeAvatar/ charAvatar.length : sizeAvatar * 0.8) + 'px'"
>{{charAvatar}}</div>
